module.exports = __webpack_public_path__ + "static/media/sun.2e11ba03.svg";